document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".dom-loading").forEach(el => {
		el.classList.remove("dom-loading");
		el.classList.add("dom-loaded");
	});
});